import * as angular from 'angular';
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsEvents} from "../../shared/dto/aps.events";
import {SignalRHub} from "../hubs/signalr-hub";
import HubServiceName, {HubService} from "../hubs/hub.service";

export interface KPIChecksHub extends SignalRHub {
  joinGroup(shopId: string, wellKnownCheck: apsEnums.WellKnownCheckType): Promise<any>;
  leaveGroup(shopId: string, wellKnownCheck: apsEnums.WellKnownCheckType): Promise<any>;
}

export interface KPIChecksHubService {
  createKPIChecksHub(updateResult: (update: apsEvents.WellKnownCheckUpdated) => void,
                     shopId: string,
                     wellKnownCheck: apsEnums.WellKnownCheckType): KPIChecksHub;
}

export default angular.module('aps.hubs.kpiChecks', [HubServiceName])
  .service('kpiChecksHubService', function (hubService: HubService) {

    function createKPIChecksHub(updateResult: (update: apsEvents.WellKnownCheckUpdated) => void,
                                shopId: string,
                                wellKnownCheck: apsEnums.WellKnownCheckType): KPIChecksHub {

      return hubService.createHub<KPIChecksHub>('wellKnownCheck', {
        allowMultipleListeners: true,
        listeners: {
          wellKnownCheckUpdated: (wellKnownCheckUpdated: apsEvents.WellKnownCheckUpdated) => {
            if (wellKnownCheckUpdated
              && (wellKnownCheckUpdated.shopId === shopId)
              && (wellKnownCheckUpdated.wellKnownCheck === wellKnownCheck)) {
              updateResult(wellKnownCheckUpdated);
            }
          }
        },
        methods: ['leaveGroup', 'joinGroup'],
        postConnect: (hub: KPIChecksHub) => {
          hub.invokeWithRetry(() => hub.joinGroup(shopId, wellKnownCheck));
        }
      });
    }

    return <KPIChecksHubService>{
      createKPIChecksHub: createKPIChecksHub
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/checkLists/kpiChecks.hub.ts